import type { VagaListagem } from "@/types/vaga";
import { VagasListRow } from "./VagasListRow";

interface VagasListTableProps {
  vagas: VagaListagem[];
}

export function VagasListTable({ vagas }: VagasListTableProps) {
  return (
    <div className="overflow-x-auto rounded-lg border">
      <table className="w-full text-sm">
        <thead className="bg-muted/50">
          <tr className="border-b text-left">
            <th className="px-3 py-2 font-medium">Agência</th>
            <th className="px-3 py-2 font-medium">Área</th>
            <th className="px-3 py-2 font-medium">Verba</th>
            <th className="px-3 py-2 font-medium">Status</th>
            <th className="px-3 py-2 font-medium">Deadline</th>
            <th className="px-3 py-2 font-medium" title="Shortlist / Aprovados no kanban">
              Short. / Aprov.
            </th>
            <th className="px-3 py-2 font-medium">Cadastro</th>
            <th className="px-3 py-2 font-medium">Aprov./Reprov.</th>
            <th className="w-[56px] px-3 py-2" />
          </tr>
        </thead>
        <tbody>
          {vagas.map((vaga) => (
            <VagasListRow key={vaga.id} vaga={vaga} />
          ))}
        </tbody>
      </table>
    </div>
  );
}
